import { setDetailRaw } from '../../action/raw';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = null;

export default createReducer(
  [forAction(setDetailRaw, identityPayload)],
  initialState,
);
